import { render, staticRenderFns } from "./HistorialModalComponent.vue?vue&type=template&id=6c175ed8"
import script from "./HistorialModalComponent.vue?vue&type=script&lang=js"
export * from "./HistorialModalComponent.vue?vue&type=script&lang=js"
import style0 from "./HistorialModalComponent.vue?vue&type=style&index=0&id=6c175ed8&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\laragon\\www\\capredena\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6c175ed8')) {
      api.createRecord('6c175ed8', component.options)
    } else {
      api.reload('6c175ed8', component.options)
    }
    module.hot.accept("./HistorialModalComponent.vue?vue&type=template&id=6c175ed8", function () {
      api.rerender('6c175ed8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/vue/components/modals/HistorialModalComponent.vue"
export default component.exports